export const headerOptions = [
    { key: "Accept", value: "text/html,application/xhtml+xml,application/xml;q=0.9,image/webp,*/*;q=0.8" },
    { key: "Accept-Encoding", value: "gzip, deflate, br" },
    { key: "Accept-Language", value: "en-US,en;q=0.9,nl;q=0.8" },
    { key: "Upgrade-Insecure-Requests", value: "1" }
];

export const INITIAL_CONFIG_DATA = {
    branch_code: null,
    enabled: true,
    receiver_code: null,
    retry_rules_configuration: {
        count_retries: 5,
        proxy_routing_rules: [],
        retry_rules: [
            {
                action_codes: [],
                condition: "0",
                type_code: "HTTP_RESPONSE_CODE_EQUAL"
            },
            {
                action_codes: [],
                condition: "403",
                type_code: "HTTP_RESPONSE_CODE_EQUAL"
            },
            {
                action_codes: [],
                condition: "500",
                type_code: "HTTP_RESPONSE_CODE_EQUAL"
            },
            {
                action_codes: [],
                condition: "502",
                type_code: "HTTP_RESPONSE_CODE_EQUAL"
            },
            {
                action_codes: [],
                condition: "503",
                type_code: "HTTP_RESPONSE_CODE_EQUAL"
            },
            {
                action_codes: [],
                condition: "504",
                type_code: "HTTP_RESPONSE_CODE_EQUAL"
            }
        ]
    },
    sandbox_mode: true,
    default: false,
    start_limit_configuration: {
        max_count_tasks_for_branch: 20000,
        max_delay_percent: 25,
    },
    start_request_configuration: {
        disable_referer_header_option: false,
        method: "GET",
        is_callback: false,
        use_cookie: false,
        proxy_type_code: "PROXY_MANAGER",
        render_javascript: false,
        header_options: headerOptions,
        proxy: null,
        proxy_query: null,
        response_provider_code: "provider.http-provider",
        user_agent: "",
        response_provider_timeout_in_second: 30,
        wait_after_getting_http_response_in_second: 0,
        allowed_content_types: [ "*/*" ],
        max_content_length_to_download_in_bytes: 10485760,
        custom_search_url_patterns: []
    },
    ab_test_configuration: {
        exclude_browser_source_type_codes: [],
    },
    templates: [],
    sibling_branch_codes: [],
    worker: { count_workers: 20 }
};
